import { z } from "zod";
import { DATE_RANGE, VENDOR } from "./consts";

export const schema = z.object({
  [VENDOR]: z.array(z.string()).optional(),
  [DATE_RANGE]: z.any().optional(),
});

export type formValues = z.infer<typeof schema>;
